import { Reveal } from "./Reveal";

export function Contact() {
  return (
    <section
      id="vision"
      className="scroll-mt-24 relative isolate overflow-hidden border-t border-hairline"
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(75% 110% at 50% 125%, color-mix(in oklab, var(--primary) 24%, transparent), transparent 70%)",
        }}
      />
      <svg
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 h-full w-full"
        viewBox="0 0 1440 600"
        preserveAspectRatio="xMidYMid slice"
        fill="none"
      >
        <defs>
          <linearGradient id="bmt-close" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="var(--primary)" stopOpacity="0" />
            <stop offset="50%" stopColor="var(--primary)" stopOpacity="0.5" />
            <stop offset="100%" stopColor="var(--primary)" stopOpacity="0" />
          </linearGradient>
        </defs>
        <path d="M -100 520 C 400 300, 1040 300, 1540 520" stroke="url(#bmt-close)" strokeWidth="1" />
        <path d="M -100 600 C 400 380, 1040 380, 1540 600" stroke="url(#bmt-close)" strokeWidth="1" opacity="0.5" />
        <circle cx="720" cy="382" r="2.5" fill="white" style={{ animation: "bmt-twinkle 6s ease-in-out infinite" }} />
      </svg>

      <div className="relative mx-auto max-w-[1400px] px-6 py-28 text-center md:px-10 sm:py-36 lg:py-44">
        <Reveal>
          <p className="eyebrow">Vision</p>
          <h2 className="mx-auto mt-8 max-w-[16ch] font-display text-[clamp(2.25rem,7.4vw,5.25rem)] leading-[0.96] tracking-[-0.04em]">
            Building what comes next.
          </h2>
          <p className="mx-auto mt-8 max-w-xl text-base leading-relaxed text-muted-foreground">
            We design, build, deploy and operate the systems modern products depend on —
            engineered to stay dependable well beyond launch.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
